export default __webpack_public_path__ + "static/media/124C.c4338709.jpg";